// @flow

import * as React from 'react';
import {css} from '@emotion/core';
import colors from "../../../Styles/colors";
import mq from "../../../Styles/breakpoints";
import {fontSize} from "../../../Styles/text";
import type {Channel} from "../../Objects";
import {channelDisplayName} from "../../helpers";

let channelCols = [0, 1, 2, 3, 4].map(i => {
  return Array(i).fill('[channel] 1fr').join(' ');
});

let channelLabels = [0, 1, 2, 3, 4].map(i => css`
  background: ${colors.coreColor2};
  border-bottom: 1px solid ${colors.disabled};
  display: none;
  
  grid-gap: 0;
  grid-template-columns: ${channelCols[i]};
  -ms-grid-columns: 1fr 1fr 1fr 1fr;
  
  ${mq.large(`
    margin: 0;
    display: grid;
    display: -ms-grid;
    
    grid-template-columns: [col] 80px ${channelCols[i]};
    -ms-grid-columns: 80px 1fr 1fr 1fr 1fr;
  `)};
  
  @media print {
    margin: 0;
    border: 1px solid ${colors.disabled};
    display: grid;
    display: -ms-grid;
    
    grid-template-columns: [col] 80px ${channelCols[i]};
    -ms-grid-columns: 80px 1fr 1fr 1fr 1fr;
  }
`);

let channelControls = [0, 1, 2, 3, 4].map(i => css`
  background: ${colors.coreColor2};
  border-bottom: 1px solid ${colors.disabled};
  display: grid;
  display: -ms-grid;
  
  grid-gap: 0;
  grid-template-columns: ${channelCols[i]};
  -ms-grid-columns: 1fr 1fr 1fr 1fr;
  
  ${mq.large(`
    margin: 0;
    display: none;
    
    grid-template-columns: [col] 80px ${channelCols[i]};
    -ms-grid-columns: 80px 1fr 1fr 1fr 1fr;
  `)};
  
  @media print {
    display: none;
  }
`);

let channelLabelColors = [
  colors.main,
  colors.secondary,
  colors.highlight,
  colors.accent
];

let channelLabel = css`
  margin: 0;
  padding: 8px 0;
  background: ${colors.coreColor2};
  ${fontSize(5)};
  font-weight: bold;
  color: ${colors.coreColor1};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  border-right: 2px solid ${colors.coreColor1};
  
  -ms-grid-column-span: 1;
  
  &:last-child {
    border: none;
  }
  
  ${mq.large(`
    padding: 4px 0;
    ${fontSize(4)};
    border: none;
  `)}
`;

let channelLabelButton = css`
  margin: 0;
  padding: 8px 0;
  background: ${colors.coreColor2};
  ${fontSize(5)};
  font-weight: bold;
  color: ${colors.coreColor1};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  border-right: 2px solid ${colors.coreColor1};
  
  &:last-child {
    border: none;
  }
  
  ${mq.large(`
    padding: 4px 0;
    ${fontSize(4)};
    border: none;
  `)}
  
  &:hover {
    background: ${colors.coreColor2};
    color: ${colors.coreColor1};
  }  
`;

type Props = {|
  channelList: Array<Channel>,
  current: number,
  changeChannel: (index: number, scroll: boolean) => void
|};

export default class Channels extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    let { channelList, current, changeChannel, enableChannelColors = true } = this.props;

    return <React.Fragment>
      {/* Large size channel labels */}
      <div css={channelLabels[channelList.length]}>
        <span />
        {
          channelList.map((channel, index) => {
            let styles = {
              color: enableChannelColors ? channelLabelColors[index] : undefined,
              msGridColumn: index + 2
            };

            return <span css={channelLabel} style={styles} key={channel}>
              {channelDisplayName(channel)}
            </span>;
          })
        }
      </div>
      {/* Mobile channel controls */}
      <div css={channelControls[channelList.length]}>
        {
          channelList.map((channel, index) => {
            let styles = {};

            if (index === current) {
              styles = {
                backgroundColor: colors.main,
                color: colors.coreColor2
              };
            }

            return <button css={channelLabelButton} onClick={() => {changeChannel(index, true)}} style={styles} key={channel}>
              {channelDisplayName(channel)}
            </button>;
          })
        }
      </div>
    </React.Fragment>
  }
}